import axios from "axios"
import { AccountInformationReturn, AccountSubscriptionInfoReturn, StudentAccountCreateProps, StudentAccountOptionsReturn, StudentAccountResetPasswordProps, StudentPageAccessOptions, TeacherPasswordChangeProps, UpdateAccountInformationProps } from "shared/types/accountManagementTypes"

const BASE_API_URL = "/api/account-management"

export async function getCustomerInfo(): Promise<AccountInformationReturn> {
    const res = await axios.get(BASE_API_URL + "/information")
    return res.data
}

export async function updateCustomerInfo({ name, email, state, county, password } : UpdateAccountInformationProps) {
    return await axios.post(BASE_API_URL + "/information", { name, email, state, county, password })
}

export async function changeCustomerPassword({ currentPassword, newPassword, confirmNewPassword } : TeacherPasswordChangeProps) {
    return await axios.put(BASE_API_URL + "/change-password", { currentPassword, newPassword, confirmNewPassword })
}

export async function getSubscriptionInfo(): Promise<AccountSubscriptionInfoReturn> {
    const res = await axios.get(BASE_API_URL + "/subscription-info")
    return res.data
}

export async function getStudentAccountInfo(): Promise<StudentAccountOptionsReturn> {
    const res = await axios.get(BASE_API_URL + "/student-account-options")
    return res.data
}

export async function resetStudentAccountPassword({ currentTeacherPassword, newStudentPassword, confirmStudentPassword } : StudentAccountResetPasswordProps) {
    const res = await axios.put(BASE_API_URL + "/student-account-options/reset-password", { currentTeacherPassword, newStudentPassword, confirmStudentPassword })
    return res.data
}

export async function updatePageAccess({ hasBackgroundAccess, hasAssesmentAccess, hasMethodsAccess } : StudentPageAccessOptions) {
    const res = await axios.put(BASE_API_URL + "/student-account-options/update-page-access", { hasBackgroundAccess, hasAssesmentAccess, hasMethodsAccess })
    return res.data
}

export async function createStudentAccount({ username, password, confirmPassword } : StudentAccountCreateProps) {
    const res = await axios.post(BASE_API_URL + "/student-account-options/create", { username, password, confirmPassword })
    return res.data
}
